<template class="bg-app h-screen">
  <div>
    <div class="bg-app">
      <div class="container mx-auto">
        <div
          class="h-screen overflow-hidden flex items-center justify-center bg-black bg-opacity-50"
        >
          <div class="flex flex-col items-center m-8">
            <div class="w-full rounded overflow-x-hidden flex snap-x">
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-1"
              >
                <img
                  src="../assets/images/slides/slide-1.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-2"
              >
                <img
                  src="../assets/images/slides/slide-2.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-3"
              >
                <img
                  src="../assets/images/slides/slide-3.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-4"
              >
                <img
                  src="../assets/images/slides/slide-4.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-5"
              >
                <img
                  src="../assets/images/slides/slide-5.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-6"
              >
                <img
                  src="../assets/images/slides/slide-6.jpg"
                  class="rounded"
                />
              </div>
              <div
                class="snap-start w-full h-full flex items-center justify-center flex-shrink-0"
                id="slide-7"
              >
                <img
                  src="../assets/images/slides/slide-7.jpg"
                  class="rounded"
                />
              </div>
            </div>

            <div class="flex mt-4">
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-1"
                >1</a
              >
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-2"
                >2</a
              >
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-3"
                >3</a
              >
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-4"
                >4</a
              >
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-5"
                >5</a
              >
              <a
                class="w-8 mr-1 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-6"
                >6</a
              >
              <a
                class="w-8 h-8 text-green-700 rounded-full bg-white flex justify-center items-center"
                href="#slide-7"
                >7</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slides",
};
</script>



// WEBPACK FOOTER //
// src/components/Slides.vue